$(function () {
  /* Setup */
  Vue.config.devtools = true;
  var endPoint = '/data/searchResults.json';

  /* Vue Application */
  var app = new Vue({
    delimiters: ['{{', '}}'],
    data: {
      'search': '',
      'searching': null,
      'numResults': 5,
      'callback': '',
      'results': []
    },

    watch: {
      search: function (val) {
        self = this;
        // This will wait to send the search query until the user
        // is "done" typing, or until they slow their typing
        clearTimeout(this.searching);
        this.searching = setTimeout(function () {
          if (val.length > 2) {
            self.showSearchResults();
            self.callback = "";
            self.searchSubmit();
          } else if (val.length > 0) {
            // self.hideSearchResults();
            self.results = [];
            self.callback = "Please enter at least 3 characters";
            self.showSearchResults();
          } else {
            // self.hideSearchResults();
            self.results = [];
            self.hideSearchResults();
          }
        }, 300);
      }
    },

    methods: {
      getResults: function () {
        // We're going to need to pass this.search
        var self = this;
        var searchParams = {
          search: self.search,
        };
        $.get(endPoint, searchParams)
          .done(function (data) {
            // Filter down to top X results if more than X returned
            var results = [];
            results = _.filter(data.results, function (result) {
              var name = (result.name) ? result.name.toLowerCase().search(self.search.toLowerCase()) : -1;
              return name >= 0;
            });
            if (results.length > 0) {
              self.results = (results.length > self.numResults) ? _.take(results, self.numResults) : results;
              self.callback = '';
            } else {
              self.results = [];
              self.callback = 'No results found.';
            }

          })
          .fail(function (data) {
            self.results = [];
            self.callback = 'Sorry, something went wrong.';
          });
      },

      showSearch: function () {
        if ($('#quick-home-search').hasClass('is-button')) {
          // Hide buttons, show search form
          $('#quick-home-search').removeClass('is-button');
          $('#quick-home-search--view-map').addClass('animated fadeIn');
          $('#quick-home-search--guided-button').addClass('animated fadeInDown')
            .find('a').removeClass('button button--white').addClass('plain text--white');

          $('#quick-home-search--search-field').blur();
        }
      },

      showSearchResults: function () {
        if (!$('#quick-home-search--search-results').hasClass('active')) {
          $('#quick-home-search--search-results').addClass('active');
        }
      },

      hideSearchResults: function () {
        if ($('#quick-home-search--search-results').hasClass('active')) {
          $('#quick-home-search--search-results').removeClass('active');
        }
      },

      searchSubmit: function () {
        if (this.search.length < 3) {
          return;
        }
        this.getResults();
      }

    },

    created: function () {
      // this.getResults();
    },

    mounted: function () {
      var self = this;
      var searchField = $('#quick-home-search--search-field');
      var searchResults = $('#quick-home-search--search-results');

      $(document).click(function (e) {
        var tgt = $(e.target);
        if (!tgt.is('#quick-home-search *') && !tgt.is('#quick-home-search--search-field')) {
          self.hideSearchResults();
        }
      })
    }
  });

  if ($('#quick-home-search--container').length) {
    app.$mount('#quick-home-search--container');
  }
});